import ConfirmModal from "PFComponents/confirm/confirm_modal";
import SkillRatingIcon from "PFComponents/icons/skill_rating_icon";
import { LoadingDots } from "PFComponents/loading_dots";
import Radios from "PFComponents/radios/radios";
import { Typography } from "PFComponents/typography";
import { useDictionaryConnectionCreate } from "PFCore/hooks/queries/custom_values/use_dictionary_connection_create";
import { Experience, PureCustomValue } from "PFTypes";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import marketplaceButtonTheme from "../../components/buttons/marketplace_button.module.scss";
import marketplaceTertiaryButtonTheme from "../../components/buttons/marketplace_tertiary_button.module.scss";
import { useMarketplaceContext } from "../../contexts/marketplace_context";
import css from "./add_skill_modal.module.scss";

export const AddSkillModal = () => {
  const { t } = useTranslation(["marketplace", "core"]);
  const {
    modal: { setData, setType, data }
  } = useMarketplaceContext();

  const [experience, setExperience] = useState(Experience.Basic);
  const { isLoading, mutateAsync } = useDictionaryConnectionCreate();

  const handleClose = () => {
    setType(null);
    setData(null);
  };

  const skill = data?.skill as PureCustomValue;
  const normalizeExperience = (experience: Experience): number => experience / Experience.Advanced;

  const options = useMemo(
    () => [
      {
        id: Experience.Basic,
        name: t("core:skillRatings.basic"),
        text: t("core:skillRatings.basic"),
        style: { display: "flex" },
        displayElement: <SkillRatingIcon value={normalizeExperience(Experience.Basic)} size={18} />
      },
      {
        id: Experience.Intermediate,
        name: t("core:skillRatings.intermediate"),
        text: t("core:skillRatings.intermediate"),
        style: { display: "flex" },
        displayElement: <SkillRatingIcon value={normalizeExperience(Experience.Intermediate)} size={18} />
      },

      {
        id: Experience.Advanced,
        name: t("core:skillRatings.advanced"),
        text: t("core:skillRatings.advanced"),
        style: { display: "flex" },
        displayElement: <SkillRatingIcon value={normalizeExperience(Experience.Advanced)} size={18} />
      }
    ],
    [t]
  );

  if (!skill) {
    return null;
  }

  const handleAddSkill = () => mutateAsync({ customValueId: skill.id, experience });

  return (
    <ConfirmModal
      // TODO: [PROF-1049] Use size prop for LoadingDots implemented in PR #8188
      labelOK={
        !isLoading ? (
          t("marketplace:addSkillModal.submitLabel")
        ) : (
          <LoadingDots circlesEnabled circleSize="xs" />
        )
      }
      handleOK={isLoading ? undefined : handleAddSkill}
      handleClose={handleClose}
      themeCancel={marketplaceTertiaryButtonTheme}
      themeOK={marketplaceButtonTheme}
    >
      <Typography variant="h4" noMargin>
        {t("marketplace:addSkillModal.title", { skillName: skill.text })}
      </Typography>
      <Typography variant="h5">{t("marketplace:addSkillModal.subtitle")}</Typography>
      <div className={css.radios}>
        <Radios<Experience>
          items={options}
          value={experience}
          handleChange={(item) => setExperience(item.id)}
          classes={{ item: css.experienceItem }}
          inline
        />
      </div>
    </ConfirmModal>
  );
};
